import * as React from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea, CardActions } from '@mui/material';

export default function SimpleAirdropCard(props) {
    return (
        <Card sx={{ maxWidth: 250 }}>
            <CardActionArea>
                <CardMedia
                    component="img"
                    height="250"
                    image={props.imgSrc}
                    alt="airdrop"
                />

            </CardActionArea>
            <CardActions>
                <Button size="small" color="primary">
                    Collect
                </Button>
            </CardActions>
        </Card>
    )
}